export const baseEnvironment = {
  appTitle: 'Bento',
  // must have double quotes
  "version": "1.22.2",

  // "Acest site a fost creat cu <heartIcon> de catre <bento>.",
  bodyFooterMessage: 'Acest site a fost creat de catre <bento>.',
  bodyFooterShowVersion: true
};
